import AuditWorkflow from "@/pages/AuditWorkflow";
export default function WeeklyAudit() {
  return <AuditWorkflow auditType="Weekly" />;
}
